import CreateAccount from '@/containers/CreateAccount'
import CreateAccountByInvite from '@/containers/CreateAccountByInvite'

import LandingPage from '@/containers/LandingPage'
import Login from '@/containers/LoginPage'
import ForgotPassword from '@/containers/ForgotPassword'
import RequestDemo from '@/containers/RequestDemo'

import TOS from '@/containers/yp_agreements/TOS'
import PrivacyPolicy from '@/containers/yp_agreements/PrivacyPolicy'

import Page404 from '@/containers/Page404'

export const publicRoutes = [
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage
  },

  {
    path: '/create-account/invite',
    name: 'CreateAccountByInvite',
    component: CreateAccountByInvite
  },
  {
    path: '/create-account',
    name: 'CreateAccount',
    component: CreateAccount
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/tos',
    name: 'TOS',
    component: TOS
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/request-demo',
    name: 'RequestDemo',
    component: RequestDemo
  },
  {
    path :'*',
    component: Page404
  },
  {
    path :'/not-found',
    component: Page404
  }
]



// WEBPACK FOOTER //
// ./src/router/public_routes.js